import React from "react";
import { Heading } from "web/react/emo/heading/heading";
import { Text } from "web/react/emo/text/text";
import { VStack } from "web/react/emo/v-stack/v-stack";
import { useSectionImpression } from "web/react/pages/partners/use-section-impression";
import { gettext, gettextNoop } from "web/script/modules/django-i18n";
import * as styles from "./partners-onboarding.css";

interface StepConfig {
    number: string;
    titleKey: string;
    bodyKey: string;
}

const STEPS: StepConfig[] = [
    {
        number: "01",
        titleKey: gettextNoop("partners.onboarding.step_1_title"),
        bodyKey: gettextNoop("partners.onboarding.step_1_body"),
    },
    {
        number: "02",
        titleKey: gettextNoop("partners.onboarding.step_2_title"),
        bodyKey: gettextNoop("partners.onboarding.step_2_body"),
    },
    {
        number: "03",
        titleKey: gettextNoop("partners.nav.onboarding"),
        bodyKey: gettextNoop("partners.onboarding.step_3_body"),
    },
    {
        number: "04",
        titleKey: gettextNoop("partners.onboarding.step_4_title"),
        bodyKey: gettextNoop("partners.onboarding.step_4_body"),
    },
];

export default function PartnersOnboarding(): JSX.Element {
    const sectionRef = useSectionImpression("onboarding", 7);

    return (
        <section ref={sectionRef} id="onboarding" className={styles.section}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <VStack spacing="xs">
                        <Text textStyle="caption-s" color="secondary" className={styles.eyebrow}>
                            {gettext("partners.nav.onboarding")}
                        </Text>
                        <Heading textStyle="hero-l" as="h2">
                            {gettext("partners.onboarding.headline")}
                        </Heading>
                    </VStack>
                </div>

                <div className={styles.grid}>
                    {STEPS.map(({ number, titleKey, bodyKey }) => (
                        <div key={number}>
                            <div className={styles.stepNumberWithLine}>
                                <Text textStyle="caption-s" color="secondary">
                                    {number}
                                </Text>
                            </div>
                            <VStack spacing="sm">
                                <Heading textStyle="hero-xs" as="h3">
                                    {gettext(titleKey)}
                                </Heading>
                                <Text textStyle="body" color="secondary" as="p">
                                    {gettext(bodyKey)}
                                </Text>
                            </VStack>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
